"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

var _react = require("react");

var React = _interopRequireWildcard(_react);

var _lodash = require("lodash");

var _reactBootstrap = require("react-bootstrap");

var _reactIntl = require("react-intl");

var _reactRedux = require("react-redux");

var _AppDataField = require("../../reducers/reportDetail/AppDataField");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __assign = undefined && undefined.__assign || Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) {
            if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
    }
    return t;
};
var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var ReportDetailTableRowFieldTemplate = function (_React$Component) {
    _inherits(ReportDetailTableRowFieldTemplate, _React$Component);

    function ReportDetailTableRowFieldTemplate(props) {
        _classCallCheck(this, ReportDetailTableRowFieldTemplate);

        var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(ReportDetailTableRowFieldTemplate).call(this, props));

        _this.removeItem = function () {
            _this.props.removeItem(_this.props.dispatch, _this.props.refUid);
        };
        _this.state = {
            isLoading: false,
            showTable: false
        };
        return _this;
    }

    _createClass(ReportDetailTableRowFieldTemplate, [{
        key: "render",
        value: function render() {
            var _this2 = this;

            var title = null;
            (0, _lodash.chain)(this.props.reportDetail.reportData).forEach(function (reportData) {
                var shouldContinue = true;
                (0, _lodash.chain)(reportData.dataEntries).forEach(function (reportEntryData) {
                    if (reportEntryData.uid === _this2.props.refUid) {
                        var additionalInfo = reportEntryData.additionalInfo;
                        if (additionalInfo) {
                            // console.log(reportData, reportEntryData);
                            if (reportData.dataDefinition && reportData.dataDefinition.additionalInfoTitle) {
                                title = reportEntryData.title + ", " + reportData.dataDefinition.additionalInfoTitle + ": " + additionalInfo;
                            } else {
                                title = reportEntryData.title + ", " + additionalInfo;
                            }
                        } else {
                            title = reportEntryData.title;
                        }
                        shouldContinue = false;
                    }
                    return shouldContinue;
                }).value();
                return shouldContinue;
            }).value();
            var i = -1;
            return React.createElement("tr", { className: this.props.rowHasError ? "has-error" : "" }, React.createElement("div", { style: { "width": _AppDataField.containerWidth, "display": "block", "float": "left" }, className: "row-header" }, React.createElement("td", { style: { width: "100%" } }, title), React.createElement("td", { style: { width: "100%" }, key: this.props.locals.path[0] + this.props.locals.path[1] + "rowDataButtonContainer" + "column" }, React.createElement(_reactBootstrap.Button, { className: "pull-right", bsStyle: "primary", key: this.props.locals.path[0] + this.props.locals.path[1] + "rowDataButtonContainer", onClick: function onClick() {
                    _this2.setState({ isLoading: _this2.state.isLoading, showTable: !_this2.state.showTable });
                } }, React.createElement(_reactIntl.FormattedMessage, __assign({}, this.state.showTable ? { id: "reportStep.table.hideTable" } : { id: "reportStep.table.showTable" })))), React.createElement("td", { style: { width: "100%" }, key: this.props.locals.path[0] + this.props.locals.path[1] + "buttonContainer" + "column" }, React.createElement(_reactBootstrap.Button, { className: "pull-right", bsStyle: "danger", key: this.props.locals.path[0] + this.props.locals.path[1] + "buttonContainer", disabled: this.props.locals.disabled, onClick: this.removeItem }, React.createElement(_reactIntl.FormattedMessage, { id: "reportStep.table.removeItem" })))), function () {
                return (0, _lodash.chain)(_this2.props.locals.inputs).map(function (input, index) {
                    i++;
                    // checks if it should show the row. If it is a helper which assigns a table to a object/item instance then don't show
                    var isAssign = input.key.indexOf("assignTableToInstance") !== -1;
                    return React.createElement("td", { style: { "width": "100%", "float": "left", "display": isAssign ? "none" : _this2.state.showTable ? "block" : "none" }, key: _this2.props.locals.path[0] + _this2.props.locals.path[1] + index + "column" }, _this2.props.rowTitles && _this2.props.rowTitles[i], input);
                }).value();
            }());
        }
    }]);

    return ReportDetailTableRowFieldTemplate;
}(React.Component);
ReportDetailTableRowFieldTemplate = __decorate([_reactIntl.injectIntl, (0, _reactRedux.connect)(function (state) {
    return {
        reportDetail: state.reportDetail
    };
})], ReportDetailTableRowFieldTemplate);
exports.default = ReportDetailTableRowFieldTemplate;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/containers/reportDetail/ReportDetailTableRowFieldTemplate.tsx
 ** module id = 633
 ** module chunks = 0
 **/